// Crime Statistics Agency offence classification (2015), from
// csaoffenceclassification.docx. Headings are the CSA subdivisions and the
// charges are the offence groups under each, without the CSA codes.

export const OFFENCE_CLASSIFICATION = {
  // Crimes against the person
  "Homicide and related offences": [
    "Murder",
    "Attempted murder",
    "Accessory or conspiracy to murder",
    "Manslaughter",
    "Driving causing death",
  ],
  "Assault and related offences": [
    "Serious assault",
    "Assault police, emergency services or other authorised officer",
    "Common assault",
  ],
  "Sexual offences": [
    "Rape",
    "Indecent assault",
    "Incest",
    "Sexual offences against children",
    "Other sexual offences",
  ],
  "Abduction and related offences": [
    "Abduction",
    "False imprisonment",
    "Slavery and sexual servitude offences",
  ],
  "Robbery": [
    "Aggravated robbery",
    "Non-Aggravated robbery",
  ],
  "Blackmail and extortion": [
    "Blackmail",
    "Extortion",
  ],
  "Stalking, harassment and threatening behaviour": [
    "Stalking",
    "Harassment & private nuisance",
    "Threatening behaviour",
  ],
  "Dangerous and negligent acts endangering people": [
    "Dangerous driving",
    "Neglect or ill treatment of people",
    "Throw or discharge object endangering people",
    "Other dangerous or negligent acts endangering people",
  ],
  // Property and deception offences
  "Arson": [
    "Cause damage by fire",
    "Cause a bushfire",
    "Other fire related offences",
  ],
  "Property damage": [
    "Criminal damage",
    "Graffiti",
    "Other property damage offences",
  ],
  "Burglary/Break and enter": [
    "Aggravated burglary",
    "Non-aggravated burglary",
  ],
  "Theft": [
    "Motor vehicle theft",
    "Steal from a motor vehicle",
    "Steal from a retail store",
    "Theft of a bicycle",
    "Receiving or handling stolen goods",
    "Fare evasion",
    "Other theft",
  ],
  "Deception": [
    "Forgery and counterfeiting",
    "Possess equipment to make false instrument",
    "Obtain benefit by deception",
    "State false information",
    "Deceptive business practices",
    "Professional malpractice and misrepresentation",
    "Other deception offences",
  ],
  "Bribery": [
    "Bribery of officials",
  ],
  // Drug offences
  "Drug dealing and trafficking": [
    "Drug dealing",
    "Drug trafficking",
  ],
  "Cultivate or manufacture drugs": [
    "Cultivate drugs",
    "Manufacture drugs",
    "Possess drug manufacturing equipment or precursor",
  ],
  "Drug use and possession": [
    "Drug use",
    "Drug possession",
  ],
  "Other drug offences": [
    "Other drug offences",
  ],
  // Public order and security offences
  "Weapons and explosives offences": [
    "Firearms offences",
    "Prohibited and controlled weapons offences",
    "Explosives offences",
  ],
  "Disorderly and offensive conduct": [
    "Riot and affray",
    "Drunk and disorderly in public",
    "Offensive conduct",
    "Offensive language",
    "Criminal intent",
    "Disorderly conduct",
  ],
  "Public nuisance offences": [
    "Privacy offences",
    "Hoaxes",
    "Begging",
    "Defamation and libel",
    "Improper movement on public or private space",
    "Other public nuisance offences",
  ],
  "Public security offences": [
    "Immigration offences",
    "Sabotage",
    "Hacking",
    "Terrorism offences",
    "Other public security offences",
  ],
  // Justice procedures offences
  "Justice procedures": [
    "Escape custody",
    "Fail to appear",
    "Resist or hinder officer",
    "Pervert the course of justice or commit perjury",
    "Prison regulation offences",
    "Other justice procedures offences",
  ],
  "Breaches of orders": [
    "Breach family violence order",
    "Breach intervention order",
    "Breach bail conditions",
    "Breach of other orders",
  ],
  // Other offences
  "Regulatory driving offences": [
    "Drink driving",
    "Drug driving",
    "Speeding offences",
    "Parking offences",
    "Licensing offences",
    "Registration and roadworthiness offences",
    "Other regulatory driving offences",
  ],
  "Transport regulation offences": [
    "Public transport",
    "Aviation regulations offences",
    "Maritime regulations offences",
    "Pedestrian offences",
    "Other transport regulation offences",
  ],
  "Other government regulatory offences": [
    "Betting and gaming offences",
    "Commercial regulation offences",
    "Liquor & tobacco licensing offences",
    "Pornography and censorship offences",
    "Intellectual property",
    "Prostitution offences",
    "Other government regulatory offences",
  ],
  "Miscellaneous offences": [
    "Environmental offences",
    "Public health and safety offences",
    "Cruelty to animals",
    "Dangerous substance offences",
    "Other miscellaneous offences",
  ],
};

export const OFFENCE_HEADINGS = Object.keys(OFFENCE_CLASSIFICATION);

// Older records stored headings with the CSA code in front, e.g. "B40 Theft".
export const withoutOffenceCode = (value = "") => value.replace(/^[A-F]\d{2}\s+/, "");
